import React, { useEffect, useState } from 'react'
import BaseCreatePage from '../../../../../components/hooks/BaseCreatePage'
import { Grid } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import Filter from './Filter'
import { fetchLeadsReport } from '../LeadsReportsActions'
import List from './List'

const LeadsReport = () => {
  const items = useSelector(state => state.leadsReport.items)
  const dispatch = useDispatch()

  const [form, setForm] = useState({
    per_page: 10,
    page: 1,
    attendant_id: '',
  })

  useEffect(() => {
    dispatch(fetchLeadsReport(form))
  }, [form])

  return (
    <>
      <BaseCreatePage page="Relátorios" path="Leads" hiddenReturn>
        <Grid container spacing="3" style={{ marginTop: '1em' }}>
          <Grid item xs={12}>
            <Filter form={form} setForm={setForm} />
          </Grid>
          <Grid item xs={12}>
            <List setForm={setForm} form={form} />
          </Grid>
        </Grid>
      </BaseCreatePage>
    </>
  )
}

export default LeadsReport
